import { type Action, createActionsHook, createHook, createStore } from 'react-sweet-state';

export type TourStep = number;

type TourState = {
	stepNumber: TourStep;
	totalSteps: number;
	hasDismissed: boolean;
	hasStarted: boolean;
};

const initialState: TourState = {
	stepNumber: 0,
	totalSteps: 3,
	hasDismissed: false,
	hasStarted: false,
};

const setStepNumber: (step: TourStep) => Action<TourState, any, any> = (step: TourStep) => {
	return ({ setState }) => {
		setState({
			stepNumber: step,
		});
	};
};

const nextStep: () => Action<TourState, any, any> = () => {
	return ({ setState, getState }) => {
		const { stepNumber } = getState();
		const nextStepValue = stepNumber + 1;

		setState({
			stepNumber: nextStepValue > initialState.totalSteps ? 0 : nextStepValue,
		});
	};
};

const previousStep: () => Action<TourState, any, any> = () => {
	return ({ setState, getState }) => {
		const { stepNumber } = getState();
		const nextStepValue = stepNumber - 1;

		setState({
			stepNumber: nextStepValue < 1 ? 1 : nextStepValue,
		});
	};
};

const resetStep: () => Action<TourState, any, any> = () => {
	return ({ setState }) => {
		setState({
			stepNumber: 1,
			hasStarted: true,
		});
	};
};

const dismiss: () => Action<TourState, any, any> = () => {
	return ({ setState }) => {
		setState({
			stepNumber: 0,
			hasDismissed: true,
		});
	};
};

const store = createStore({
	initialState,
	actions: {
		setStepNumber:
			(step: TourStep) =>
			({ dispatch }) => {
				dispatch(setStepNumber(step));
			},

		nextStep:
			() =>
			({ dispatch }) => {
				dispatch(nextStep());
			},
		previousStep:
			() =>
			({ dispatch }) => {
				dispatch(previousStep());
			},
		resetStep:
			() =>
			({ dispatch }) => {
				dispatch(resetStep());
			},
		dismiss:
			() =>
			({ dispatch }) => {
				dispatch(dismiss());
			},
	},
});

export const useGettingStartedTourStore = createHook(store);
export const useGettingStartedTourStoreActions = createActionsHook(store);

export const useGettingStartedTourState = () => {
	const [state] = useGettingStartedTourStore();
	return state;
};
